import { render } from "./TalkGroup.vue?vue&type=template&id=170f1139&scoped=true"
import script from "./TalkGroup.vue?vue&type=script&lang=js"
export * from "./TalkGroup.vue?vue&type=script&lang=js"

import "./TalkGroup.vue?vue&type=style&index=0&id=170f1139&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-170f1139"]])

export default __exports__